<template>

  <aside class="mt-10 mb-3 border-b border-red-200">
    <h3 class="text-lg ">
      <span>{{ setMatText.label_connector_main[lang] }}</span>
      <span>{{ setMatText.header_configuration[lang] }}</span>
    </h3>
    <nav class="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-6 items-end mb-5">
      <div>
        <label class="block text-sm font-medium "
               for="setCaseForm"
        >{{ setMatText.select_label_case_form[lang] }}</label>

        <select v-model="setCaseForm"
                class="input-md w-full"
        >
          <option v-for="cform in caseforms"
                  :value="cform.short"
                  v-text="cform.value[lang]"
          ></option>
        </select>

      </div>

      <div>
        <label class="block text-sm font-medium "
               for="setCaseMat"
        >{{ setMatText.select_label_caseing[lang] }}</label>

        <select v-model="setCaseMat"
                class="input-md w-full"
        >
          <option v-for="cmat in casematerials"
                  :value="cmat.short"
                  v-text="cmat.value[lang]"
          ></option>
        </select>

      </div>

      <div>
        <label class="block text-sm font-medium "
               for="setPins"
        >{{ setMatText.select_label_pin_num[lang] }}</label>

        <select v-model="setPins"
                class="input-md w-full"
        >
          <option v-for="tpnum in pinnums"
                  :value="tpnum.short"
                  v-text="tpnum.value"
          ></option>
        </select>

      </div>

      <div>
        <label class="block text-sm font-medium "
               for="setGender"
        >{{ setMatText.select_label_type[lang] }}</label>

        <select v-model="setGender"
                class="input-md w-full"
        >
          <option v-for="gen in genders"
                  :value="gen.short"
                  v-text="gen.value[lang]"
          ></option>
        </select>

      </div>

      <div>
        <label class="block text-sm font-medium "
               for="setTpType"
        >{{ setMatText.input_label_set_type_tp[lang] }}</label>
        <select v-model="setTpType"
                class="input-md w-full"
        >
          <option v-for="tptype in tptypes"
                  :value="tptype.short"
                  v-text="tptype.value"
          ></option>
        </select>
      </div>


      <button class="button-set col-span-1"
              type="button"
              @click="addSpec()"
      ><span class="inline mx-3">{{ setMatText.btn_label_add_specification[lang] }}</span>
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 384 512"
             class="w-3 h-3 sm:w-4 sm:h-4 text-red-500"
        ><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
          <path d="M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"
                style="fill:currentColor"
          />
        </svg>

      </button>

    </nav>

  </aside>

</template>
<script setup>

import {ref} from "vue";
import setMatText from "../../lang/setMaterials.json";
import {caseforms, casematerials, genders, pinnums, tptypes,} from "../configs/config-main";

const props = defineProps({
  lang: {
    type: String,
    default: 'de'
  }
})

const emits = defineEmits(['setnewpostext'])

const setNewPosText = ref('')
const setPins = ref('P2')
const setTpType = ref('K')
const setCaseMat = ref('ST')
const setCaseForm = ref('MC')
const setGender = ref('M')


const addSpec = () => {

  let pinString = setPins.value === 'P2' ? '' : pinnums[setPins.value].value + ' '

  setNewPosText.value = `${pinString}${caseforms[setCaseForm.value].value[props.lang]} ${setMatText.label_connector_main[props.lang]} ${casematerials[setCaseMat.value].value[props.lang]}, ${setMatText.select_label_type[props.lang]} ${tptypes[setTpType.value].short},  ${genders[setGender.value].value[props.lang]}`

  emits('setnewpostext', setNewPosText.value)

}

</script>